"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackItem = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TrackItem = function TrackItem(props) {
  var sourcePercent = props.sourcePercent,
      targetPercent = props.targetPercent,
      getTrackProps = props.getTrackProps,
      className = props.className;
  var trackProps = (0, _react.useMemo)(function () {
    return getTrackProps();
  }, [getTrackProps]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    style: {
      left: "".concat(sourcePercent, "%"),
      width: "".concat(targetPercent - sourcePercent, "%")
    },
    className: className
  }, trackProps));
};

exports.TrackItem = TrackItem;
TrackItem.propTypes = {
  className: _propTypes.string.isRequired,
  sourcePercent: _propTypes.number.isRequired,
  targetPercent: _propTypes.number.isRequired,
  getTrackProps: _propTypes.func.isRequired
};
TrackItem.defaultProps = {};